function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoto = function SvgPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 54 54",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M-.067-.161h53.15v53.264H-.067z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(1.0035 0 0 1.00136 .067 .161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8a2.5 2.5 0 0 1 2.5 2.5v.5h17a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V15a4 4 0 0 1 3-3.874V10.5A2.5 2.5 0 0 1 8.5 8zM33 13H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h26a2 2 0 0 0 2-2V15a2 2 0 0 0-2-2m-13 2a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 2a5 5 0 1 0 .001 10.001A5 5 0 0 0 20 17m10-2a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-16.5-5h-5a.5.5 0 0 0-.5.5v.5h6v-.5a.5.5 0 0 0-.5-.5",
    style: {
      fill: "#8a929b"
    },
    transform: "scale(1.33333)"
  }));
};
export default SvgPhoto;